import type { TenantConfig } from '@/types/TenantConfig'

export const artsmia: TenantConfig = {
  logo: 'assets/artsmia/static/logo.svg',
  themeOptions: {
    dialog: {
      headerBackground: '#000000',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
    },
    mobileFooter: {
      textColor: '#231f20',
      priceTextColor: '#231f20',
    },
  },
  teaserImageSize: {
    width: 360,
    height: 240,
  },
  componentOptions: {
    // stripeCreditCard: {
    //   fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    // },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/artsmia/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
